import { useLocation } from 'react-router';
import { AuthLayout, TextLink } from '../../components/ui';

const NEXT = [
  ['You confirm your email.', 'Your application goes into our review queue.'],
  [
    'We review it by hand.',
    'If something isn’t clear, we email you a question you can answer from a link.',
  ],
  [
    'We email you our decision.',
    'Approved: a link to set up your developer account (with two-factor) and create your first project.',
  ],
] as const;

/** Shown after the apply form; the address comes from the form (router state). */
export function DeveloperApplySent() {
  const location = useLocation();
  const email = (location.state as { email?: string } | null)?.email;
  return (
    <AuthLayout title="Check your email">
      <p className="text-ink">
        We sent a link to {email ? <strong>{email}</strong> : 'the address you gave'}. Open it to
        confirm your application. The link works for 24 hours.
      </p>
      <p className="mt-4 text-sm text-muted">
        Nothing there? Check spam, or{' '}
        <TextLink to="/developers/apply">send the form again</TextLink>.
      </p>
      <h2 className="mt-8 text-base font-bold text-ink">What happens next</h2>
      <ol className="mt-4 space-y-4">
        {NEXT.map(([title, body], index) => (
          <li key={title} className="flex gap-3">
            <span className="flex size-7 shrink-0 items-center justify-center rounded-full bg-brand text-sm font-bold text-ink">
              {index + 1}
            </span>
            <p className="text-sm leading-relaxed text-muted">
              <strong className="block text-ink">{title}</strong>
              {body}
            </p>
          </li>
        ))}
      </ol>
    </AuthLayout>
  );
}
